var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import MUITextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    filledInput: {
        backgroundColor: theme.palette.grey[50],
        '&:hover': {
            backgroundColor: theme.palette.grey[50],
        },
        '&:focus': {
            backgroundColor: theme.palette.grey[50],
        },
        '&:active': {
            backgroundColor: theme.palette.grey[50],
        },
        '&:visited': {
            backgroundColor: theme.palette.grey[50],
        },
        '&:focus-within': {
            backgroundColor: theme.palette.grey[50],
        },
    },
}); });
var TextField = function (_a) {
    var _b;
    var _c;
    var variant = _a.variant, _d = _a.InputProps, InputProps = _d === void 0 ? {} : _d, rest = __rest(_a, ["variant", "InputProps"]);
    var classes = useStyles();
    return (React.createElement(MUITextField, __assign({ variant: variant, InputProps: __assign(__assign({}, InputProps), { classes: __assign(__assign({}, InputProps.classes), { root: cx((_b = {},
                    _b[classes.filledInput] = variant === 'filled',
                    _b), (_c = InputProps.classes) === null || _c === void 0 ? void 0 : _c.root) }) }) }, rest)));
};
export default TextField;
//# sourceMappingURL=index.js.map